import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Resume } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-add-hobbies',
  templateUrl: './add-hobbies.component.html',
  styleUrls: ['./add-hobbies.component.css']
})
export class AddHobbiesComponent implements OnInit {
  public resume: Resume = {} as Resume;
  public valueStack: any;
  public descs = [
    '<p>Teach ballet classes to children on weekends.</p>',
    '<p>Enjoy playing chess, and started a chess club in my community.</p>',
    '<p>Occasionally play music at retirement homes.</p>',
    '<p>Enjoy reading complicated spy novels.</p>',
    '<p>Volunteer at my local animal shelter on weekends.</p>',
    '<p>Cooking, specifically Indian cuisine.</p>',
    '<p>Solve mathematical puzzle &amp; riddles.</p>',
    '<p>Travelling: Visited 12+ countries.</p>',
    '<p>Reading: Read over 50 books in 2 languages this year.</p>',
    '<p>Hiking: Completed the Ironman Trail.</p>',
    '<p>Robotics: Built several functional robots.</p>'
  ];
  constructor(
    private router: Router,
    private authService: AuthService,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    public utilService: UtilService
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.valueStack = res;
        this.resume = res.Resume;
      });
    }
  }
  save() {
    this.resumeService.editResume(this.resume).subscribe(res => {
      this.resume = res.resume;
      this.router.navigate(['/resume/accomplishments']);
    });
  }
  append(model, html) {
    model.hobbies += html;
  }

  ngOnInit() {
  }
  skip() {
    const other_field = this.localStorageService.get('other_field') as string;
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    if (other_field) {
      this.router.navigate(['/resume/lang'], {queryParams: {f: other_field}})
    } else {
      this.router.navigate(['/themes/' + theme_id]);
    }
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }

}
